import PropTypes from "prop-types";
import Bread from "../../Components/Bread/BreadDynamic";
import { Container } from "@mui/material";
import useSettings from "../../Context/Hooks/useSettings";
import { useLocation } from "react-router-dom";

const Viewport = ({ children }) => {
    const { settings } = useSettings();
    const location = useLocation();

    // Gateway routes manage their own page headers — suppress the template breadcrumb
    const isGatewayRoute = location.pathname.startsWith('/Gateway');

    return (
        <Container maxWidth={settings.compact ? 'xl' : false}>
            {!isGatewayRoute && <Bread />}
            {children}
        </Container>
    );
};

Viewport.propTypes = {
    children: PropTypes.node,
};

export default Viewport;
